export class Credentials {
  email = {
    user: null,
    password: null
  };
  appleToken = null;
  googleToken = null;

  constructor(email, password, appleToken, googleToken) {
    if (email == null || password == null) {
      this.email = null;
    } else {
      this.email = {
        user: email,
        password: password
      };
    }
    this.appleToken = appleToken;
    this.googleToken = googleToken;
  }

  toJSON() {
    return {
      email: this.email,
      appleToken: this.appleToken,
      googleToken: this.googleToken
    };
  }
}
